export const BaseLineAppearance = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667V1.33333Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667V1.33333Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path d="M8 12H3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 9.33333H1.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 6.66667H1.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 4H3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
